import { Star } from "lucide-react";

export default function StarRating({ value = 0, onChange, size = 16, idPrefix = "star", tone = "gold" }) {
  const interactive = typeof onChange === "function";
  const activeCls = tone === "violet" ? "fill-[#8B5CF6] text-[#8B5CF6]" : "fill-gold text-gold";
  return (
    <div className="flex items-center gap-0.5" data-testid={`${idPrefix}-rating`}>
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type={interactive ? "button" : undefined}
          data-testid={interactive ? `${idPrefix}-star-${n}` : undefined}
          onClick={interactive ? () => onChange(n) : undefined}
          className={interactive ? "cursor-pointer transition-transform duration-150 hover:scale-125" : "cursor-default"}
          tabIndex={interactive ? 0 : -1}
        >
          <Star
            size={size}
            className={n <= Math.round(value) ? activeCls : "text-line"}
          />
        </button>
      ))}
    </div>
  );
}
